<template>
  <div class="helpSignBox">
      <div class="helpcloginCon">
          <div class="bigTitle" @click="backFn('showa')"><span ></span>合同模板的查看与购买</div>
          <div class="smallTile" v-for="(item,index) in flowList" v-if="showa">
            <p>{{item.con}} </p>
            <img :src="item.img" v-if="item.img!=''">
          </div>
          <div class="bigTitle" @click="backFn('showb')"><span ></span>发起签约</div>
          <div class="smallTile" v-for="(item,index) in initiateList"  v-if="showb">
            <p>{{item.con}} </p>
             <img :src="item.img" v-if="item.img!=''">
          </div> 
          <div class="bigTitle"  @click="backFn('showc')"><span></span>签约方签约</div>
          <div class="smallTile" v-for="(item,index) in signatoryList"  v-if="showc">
            <p>{{item.con}} </p>
            <img :src="item.img" v-if="item.img!=''">
          </div> 
          <div class="bigTitle" @click="backFn('showd')"><span ></span>签约过程中的常见问题</div>
        <div class="helpItem" v-if="showd">
          <div v-for="item in realList">
            <p><span></span>{{item.problem}}</p>
            <p><span></span>{{item.answer}}</p>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
  export default {
    data(){
      return{
        showa:false,
        showb:false,
        showc:false,
        showd:false,
        flowList:[
          {
            con:'1.签约服务-合同模板',
            img:''
          },
          {
            con:'2.按类别或按合同名称搜索要购买的合同',
            img:require('../../../assets/images/helpCenter/htmb.jpg')
          },
          {
            con:'3.点击合同名称查看合同模板',
            img:''
          },
          {
            con:'4.点击购买下载',
            img:require('../../../assets/images/helpCenter/htyl.jpg')
          },
          {
            con:'5.选择支付方式支付',
            img:''
          },
          {
            con:'6.购买成功',
            img:''
          },
          {
            con:'7.点击合同购买记录查看',
             img:require('../../../assets/images/helpCenter/htmb.jpg')
          },
        ],
        initiateList:[
          {
            con:'1.签约服务-发起签约',
            img:''
          },
          {
            con:'2.上传本地文件（PDF格式）',
           img:require('../../../assets/images/helpCenter/fqqy.jpg')
          },
          {
            con:'3.本人发起的合同勾选本人合同；被授权发起的合同勾选授权合同，选择授权人',
            img:require('../../../assets/images/helpCenter/htsq.jpg')
          },
          {
            con:'4.填写合同名称',
            img:''
          },
          {
            con:'5.选择合同有效期限',
            img:''
          },
          {
            con:'6.选择签约截止日期',
            img:''
          },
          {
            con:'7.添加签约方，点击“添加签署方”按钮添加或“从联系人添加”',
            img:''
          },
          {
            con:'8.添加签约方，点击“添加签署方”按钮添加或“从联系人添加”',
            img:''
          },
          {
            con:'9.确认提交支付，套餐-余额-微信或支付宝（支付优先级顺序由前至后）',
            img:require('../../../assets/images/helpCenter/pay.jpg')
          },
          {
            con:'10.签约创建成功',
            img:''
          },
        ],
        signatoryList:[
          {
            con:'1.签约方管理-待我签列表',
           img:''
          },
          {
            con:'2.选择要签署的合同',
           img:''
          },
          {
            con:'3.点击“去签署”或“详情”',
           img:require('../../../assets/images/helpCenter/htlb.png')
          },
          {
            con:'4.单页签章：签署详情页，选择我的签章或授权签章拖拽至合同区域',
           img:require('../../../assets/images/helpCenter/qsht.png')
          },
          {
            con:'5.骑缝签章：点击骑缝签章按钮，选择我的签章或授权签章拖拽至骑缝章区域',
           img:require('../../../assets/images/helpCenter/qfz.png')
          },
          {
            con:'6.点击提交',
           img:''
          },
          {
            con:'7.输入签约密码',
           img:require('../../../assets/images/helpCenter/srmm.png')
          },
          {
            con:'8.签约完成',
           img:require('../../../assets/images/helpCenter/qswc.png')
          },
        ],
        realList:[
          {
            problem:'合同已经完成签署，但是打开看不见签章？',
            answer:'合同已经完成签署，但是打开看不见签章？'
          },
          {
            problem:'可以不实名进行签署吗？',
            answer:'根据我国法律的要求，未实名认证用户的签约行为可能会因签约主体不明确导致无效，因此智签电子签约平台要求用户必须进行实名认证后才能签署合同。'
          },
          {
            problem:'签署完成的合同用阅读器打开显示至少有一个签名有问题，什么原因？',
            answer:'由于如Adobe Reader的类似应用大部分属于国际型应用，司法联盟链CA证书与国内CA机构颁发的证书不在Adobe Reader的证书信任链接中，所以使用类似Adobe Reader的阅读器进行电子签名有效性验证的时候需要先将CA的证书导入到Adobe Reader的信任链接中。或者登陆网址https://www.xcontract.cn，选择在线验证，将合同上传验证。'
          },
          {
            problem:'对方没有智签账号，可否发起签署？',
            answer:'一般情况下文件签署方如果有账号，添加后是会有提示的。发起时，若对方没有智签账户，可添加对方的手机号或邮箱号作为账号，发起后会以短信或邮件的方式提醒对方有待签署的文档。'
          },
          {
            problem:'签署完成后一直没有显示成功怎么办？',
            answer:'智签电子签约平台独创签约存证一体化的签约模式，签约完成后会直接在司法联盟链上进行存证，从而导致有一定的延迟，遇到“签约创建完成，正在存证”或“签署完成，正在存证”等情况，请耐心等待。'
          },
        ]
      }
    },
    methods:{
    backFn(flag){
      if(this[flag]==true){
        this[flag]=false;
      }else{
        this[flag]=true;
      }
    }
  }
  }
</script>
